module.exports = __webpack_public_path__ + "img/icon04.c7fba99d.png";